
import { NbAuthService, NbLogoutComponent } from '@nebular/auth';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { environment } from '@src/environments/environment';

@Component(
    {
        templateUrl: './hm-logout-component.html',
        selector: 'nb-logout',
    })

export class HmLogoutComponent extends NbLogoutComponent {

    constructor(protected service: NbAuthService, router: Router, protected api_service: HappyMammaService, private http: HttpClient) {
        super(service, {}, router);
    }

    logout(strategy: string): void {
        if ((this.api_service.auth_user.source == 'oauth2')) {
            try {
                let auth_app_token = JSON.parse(window.localStorage.getItem('auth_app_token'));
                window.localStorage.removeItem('auth_app_token');
                this.http.get('/api/v3/utenti/logout').toPromise()
                    .then((res) => console.log('Chiamata GET /api/v3/utenti/logout eseguita (then)', res))
                    .catch((err) => console.error('Chiamata GET /api/v3/utenti/logout eseguita (catch)', err));
                let auth_app_token_value = JSON.parse(auth_app_token.value);
                if (auth_app_token_value && auth_app_token_value.id_token) {
                    if (auth_app_token_value.role == 'superadmin'){
                        console.log("Logout superadmin, redirecting to home page");
                    }else if (auth_app_token_value.role == 'monitor'){
                        console.log("Logout monitor, redirecting to home page");
                    }else{
                        console.log("Logout user with role "+auth_app_token_value.role+", redirecting to ARPA logout");
                        window.location.href = environment.arpa_oauth2_logout +
                                        "?post_logout_redirect_uri=" +
                                        window.location.origin + 
                                        "&id_token_hint=" + 
                                        auth_app_token_value.id_token;
                    }
                } else {
                    console.error("auth_app_token not found in localStorage");
                }
            } catch (error) {
                console.error("Error parsing auth_app_token from localStorage", error);                
            }
        }else if ((this.api_service.auth_user.source == 'spagent')) {
            let img = new Image();
            img.onload = img.onerror = () => super.logout('email');
            img.src = "https://accessosicuro.rete.toscana.it/portal/c/portal/logout";
        }else {
            super.logout('email');
        }
    }
}
